import { useQuery } from '@tanstack/react-query';

import { queries } from '~extension/web2print/controller/api/Queries';
import { JobOverview } from '~extension/web2print/view/JobList/JobOverview';

export default function JobsListController({ jobStatus }: { jobStatus: string }) {
  // load list
  const { data: list } = useQuery({
    ...queries.web2print.jobList(jobStatus),
    enabled: Boolean(jobStatus),
    staleTime: 20,
    refetchOnWindowFocus: true,
  });

  return <JobOverview jobList={list} jobStatus={jobStatus} isLoading={!Boolean(list)} />;
}
